/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AllegatoDTO } from './allegato-dto';
import { RichiestaPraticaEsercenteStatus } from './richiesta-pratica-esercente-status';
import { NegozioPartecipanteDTO } from './negozio-partecipante-dto';
import { AnagraficaDTO } from './anagrafica-dto';
import { AzioneOperatoreEsercenteDTO } from './azione-operatore-esercente-dto';
import { ModalitaConvenzione } from './modalita-convenzione';
import { PraticaEsercenteEventoDTO } from './pratica-esercente-evento-dto';
import { TipoConvenzione } from './tipo-convenzione';


export interface PraticaEsercenteDetailDTO { 
    id?: string;
    codice_pratica?: string;
    stato_richiesta?: RichiestaPraticaEsercenteStatus;
    tipo_pratica_id?: string;
    tipo_pratica_titolo?: string;
    comune_slug?: string;
    tipo_convenzione?: TipoConvenzione;
    modalita_convenzione?: ModalitaConvenzione;
    percentuale_rendicontazione?: number;
    timestamp_richiesta?: string;
    nota_lavorazione?: string;
    version?: number;
    anagrafica?: AnagraficaDTO;
    form_data?: { [key: string]: any; };
    negozi?: Array<NegozioPartecipanteDTO>;
    allegati?: Array<AllegatoDTO>;
    storico?: Array<PraticaEsercenteEventoDTO>;
    azioni_operatore_disponibili?: Set<RichiestaPraticaEsercenteStatus>;
    azioni_operatore?: Array<AzioneOperatoreEsercenteDTO>;
    convenzione_da_firmare_sostituibile?: boolean;
    convenzione_bando_disponibile?: boolean;
    convenzione_bando_link?: string;
    puo_aggiungere_negozio?: boolean;
    inserita_da_operatore?: boolean;
}



